'use strict';
import Helper from '../utils/Helper';
var THEME_COLOR_NAMES = ['c', 'c--hover:hover', 'c--hover:focus'];
var BORDER_COLOR_NAMES = ['b', 'b--hover:hover', 'b--hover:focus', 'b--focus:focus'];
var BACKGROUND_COLOR_NAMES = ['bg', 'bg--hover:hover', 'bg--hover:focus', 'bg--focus:focus'];
var darkenColorHex = function (hex, percent) {
    try {
        if (hex.length === 4) {
            hex = "#".concat(Array(3).join(hex[1])).concat(Array(3).join(hex[2])).concat(Array(3).join(hex[3]));
        }
        var rgb = Helper.colorToRgb(hex);
        if (rgb === null) {
            return rgb;
        }
        var r = rgb.r, g = rgb.g, b = rgb.b;
        r = Math.round(Math.max(0, Math.min((r * ((100 - percent) / 100)), 255)));
        g = Math.round(Math.max(0, Math.min((g * ((100 - percent) / 100)), 255)));
        b = Math.round(Math.max(0, Math.min((b * ((100 - percent) / 100)), 255)));
        var rString = r.toString(16);
        var gString = g.toString(16);
        var bString = b.toString(16);
        if (rString.length === 1)
            rString = "0".concat(rString);
        if (gString.length === 1)
            gString = "0".concat(gString);
        if (bString.length === 1)
            bString = "0".concat(bString);
        return "#".concat(rString).concat(gString).concat(bString);
    }
    catch (err) {
        return hex;
    }
};
var lightenColorHex = function (hex, percent) { return darkenColorHex(hex, percent * -1); };
var buildListGridToggleStyles = function (accentColor) {
    return ".ss360-list-grid-toggle__label--active .ss360-list-grid-toggle__icon{border-color: ".concat(accentColor, ";}");
};
var ThemeColorBuilder = function (prefix, themeColor, accentColor, id) {
    var buildClassName = function (arr, isThemeColor, idString) {
        if (isThemeColor === void 0) { isThemeColor = true; }
        return arr.map(function (n) { return "".concat(idString, ".").concat(prefix, "-").concat(isThemeColor ? 't' : 'a', "c-").concat(n); }).join(',');
    };
    var build = function (arr, content, isThemeColor, idString) {
        if (isThemeColor === void 0) { isThemeColor = true; }
        return "".concat(buildClassName(arr, isThemeColor, idString), "{").concat(content, ":").concat(isThemeColor ? themeColor : accentColor, "}");
    };
    var buildThemeColor = function (idString) { return build(THEME_COLOR_NAMES, 'color', true, idString); };
    var buildBorderColor = function (idString) { return build(BORDER_COLOR_NAMES, 'border-color', true, idString); };
    var buildBackgroundColor = function (idString) { return build(BACKGROUND_COLOR_NAMES, 'background-color', true, idString); };
    var buildAccentColor = function (idString) { return (accentColor !== undefined ? build(THEME_COLOR_NAMES, 'color', false, idString) : ''); };
    var buildAccentBorderColor = function (idString) { return (accentColor !== undefined ? build(BORDER_COLOR_NAMES, 'border-color', false, idString) : ''); };
    var buildAccentBackgroundColor = function (idString) { return (accentColor !== undefined ? build(BACKGROUND_COLOR_NAMES, 'background-color', false, idString) : ''); };
    var batchBuild = function (idName) {
        var idString = idName !== undefined ? "".concat(idName, " ") : '';
        var darkAccentHex = accentColor !== undefined ? darkenColorHex(accentColor, 16) : '';
        var lightAccentHex = accentColor !== undefined ? lightenColorHex(accentColor, 70) : '';
        var darkAccentBg = accentColor !== undefined ? "".concat(idString, ".").concat(prefix, "-acd-bg--hover:hover,").concat(idString, ".").concat(prefix, "-acd-bg--hover:focus{background-color:").concat(darkAccentHex, "}") : '';
        var darkAccentBorder = accentColor !== undefined ? "".concat(idString, ".").concat(prefix, "-acd-b--hover:hover,").concat(idString, ".").concat(prefix, "-acd-b--hover:focus{border-color:").concat(darkAccentHex, "}") : '';
        var lightAccentBg = accentColor !== undefined ? "".concat(idString, ".").concat(prefix, "-acl-bg,").concat(idString, ".").concat(prefix, "-acl-bg--hover:hover,").concat(idString, ".").concat(prefix, "-acl-bg--hover:focus{background-color:").concat(lightAccentHex, "}") : '';
        var lightAccentBorder = accentColor !== undefined ? "".concat(idString, ".").concat(prefix, "-acl-b,").concat(idString, ".").concat(prefix, "-acl-b--hover:hover,").concat(idString, ".").concat(prefix, "-acl-b--hover:focus{border-color:").concat(lightAccentHex, "}") : '';
        var darkAccentColor = accentColor !== undefined ? "".concat(idString, ".").concat(prefix, "-acd-c{color:").concat(darkAccentHex, "}") : '';
        // eslint-disable-next-line max-len
        return "".concat(buildThemeColor(idString)).concat(buildBorderColor(idString)).concat(buildBackgroundColor(idString)).concat(buildAccentColor(idString)).concat(buildAccentBorderColor(idString)).concat(buildAccentBackgroundColor(idString)).concat(darkAccentBg).concat(darkAccentBorder).concat(lightAccentBg).concat(lightAccentBorder).concat(darkAccentColor).concat(buildListGridToggleStyles(accentColor));
    };
    return {
        build: function () {
            return "".concat(batchBuild()).concat(batchBuild(id));
        }
    };
};
export default ThemeColorBuilder;
